import { SmallGhostButton } from '@ardoq/button';
import { ChevronLeftIcon, ChevronRightIcon } from '@ardoq/icons';

type ButtonWithNavProps = {
  buttonLabel: string;
  buttonTooltip?: string;
  ariaNextLabel?: string;
  ariaPrevLabel?: string;
  onButtonClick?: () => void;
  isButtonDisabled?: boolean;
  onPrevClick?: () => void;
  isPrevDisabled?: boolean;
  onNextClick?: () => void;
  isNextDisabled?: boolean;
};

export const ButtonWithNav = ({
  buttonLabel,
  buttonTooltip,
  ariaNextLabel = 'Next',
  ariaPrevLabel = 'Previous',
  onButtonClick,
  isButtonDisabled,
  onPrevClick,
  isPrevDisabled,
  onNextClick,
  isNextDisabled,
}: ButtonWithNavProps) => (
  <div>
    <SmallGhostButton
      onClick={onPrevClick}
      isDisabled={isPrevDisabled}
      aria-label={ariaPrevLabel}
    >
      <ChevronLeftIcon />
    </SmallGhostButton>
    <SmallGhostButton
      isDisabled={isButtonDisabled}
      onClick={onButtonClick}
      data-tooltip-text={buttonTooltip}
    >
      {buttonLabel}
    </SmallGhostButton>
    <SmallGhostButton
      onClick={onNextClick}
      isDisabled={isNextDisabled}
      aria-label={ariaNextLabel}
    >
      <ChevronRightIcon />
    </SmallGhostButton>
  </div>
);
